import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

const INITIAL_STATE = {
  gstStatusFlag: false,
};

const gstStatusSlice = createSlice({
  name: 'gstStatus',
  initialState: INITIAL_STATE,
  reducers: {
    gst: (state) => {
      state.gstStatusFlag = true;
    },
    nonGst: (state) => {
      state.gstStatusFlag = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});

export const { gst, nonGst } = gstStatusSlice.actions;
export default gstStatusSlice.reducer;
